module.exports = __webpack_public_path__ + "img/11f758d.jpg";